import { simpleSet } from '@r/reducers/utils';

const setCalculationModeLegsOptions = simpleSet as
  redux.reducers.calculationMode.settings.materials.legs.options;

export const options = setCalculationModeLegsOptions(
  'SET_CALCULATION_MODE_LEGS_OPTIONS',
  []
);
